<template>
  <div class="home-view internal">
    <section class="form">
      <div class="container">
        <h1 class="title-default">Ficha técnica</h1>
      </div> <!-- /.container -->
    </section> <!-- /.form -->

    <section class="specs" v-if="info && info.itensFichaTecnica && info.itensFichaTecnica.length">
      <div class="container">
        <figure>
          <div><img :src="urlFiles + 'emp/' + empId + '/' + info.id + '/' + info.imagem" alt="" @click="toggleModal()"></div>

          <figcaption>
            <div class="row" v-for="(item, index) in info.itensFichaTecnica" :key="index">
              <p class="item"><strong>{{ item.nome }}:</strong> {{ item.valor }}</p>
            </div>
          </figcaption>
        </figure> <!-- /figure -->
      </div>
    </section> <!-- /.slide-status -->

    <section v-else-if="loading" class="status">
      <h2>Carregando...</h2>
    </section>

    <section v-else class="status">
      <h2>Não existe ficha técnica para o seu empreendimento.</h2>
    </section>
  </div>
</template>

<script>
import Vue from 'vue'
import PagesService from '@/services/Pages'

export default {
  name: 'ficha-tecnica',

  data () {
    const data = {
      info: null,
      empId: 0,

      loading: true,

      urlFiles: Vue.prototype.urlFiles
    }

    return data
  }, // data()

  mounted () {
    this.load()
  }, // mounted()

  methods: {
    async load () {
      try {
        let { contratoAtual } = this.$store.state
        this.empId = contratoAtual.empreendimentoIdWeb

        let xhr = await PagesService.getEmp(this.empId)
        let xhrItens = await PagesService.getFicha(this.empId)

        if (xhr && xhr.blocos && xhr.blocos.length) {
          let objFicha = xhr.blocos.find(item => item.tipo.codigo === 'FT')

          this.info = objFicha
        }

        this.info.itensFichaTecnica = this.info.itensFichaTecnica.concat(xhrItens)
        this.loading = false
      } catch (e) {
        console.error('Falha ao carregar empreendimento', e)
      }
    }, // load()

    isMobile () {
      return screen.width <= 1024
    } // isMobile()
  }, // methods

  computed: {
  } // computed
}
</script>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'

  // .main-view.-vibra
  //   fieldset.submit button
  //     background-color: map-get($colors, vibra)

  section
    h2
      text-align: center
      font-size: 18px
      margin-bottom: 40px

    &.form
      padding-bottom: 10px

    &.specs
      .container
        padding: 0 110px
        margin-bottom: 40px

      figure
        display: flex
        justify-content: space-between
        align-items: center
        width: 100%

        > div
          position: relative

          &:after
            content: ''
            position: absolute
            left: -25px
            top: -25px
            background: map-get($colors, gray)
            width: 100%
            height: 100%

          img
            position: relative
            z-index: 10
            // min-width: 450px
            max-height: 60vh
            max-width: 40vw
            width: auto
            height: auto
            cursor: pointer

        figcaption
          width: 75%
          padding-left: 5%

          .row
            width: 100%
            display: flex
            flex-direction: column

            .item
              width: 100%
              font-size: 18px
              letter-spacing: 0.25px
              margin-bottom: 15px

    @media (max-width: 1024px)
      &.specs
        .container
          $padd: 40px
          padding: 0 15px

          > div
            &:first-of-type
              padding-top: $padd

            &:last-of-type
              padding-bottom: $padd

              p:last-of-type
                margin-bottom: 0

          figure
            display: block
            align-items: initial
            justify-content: initial

            > div
              width: auto
              max-width: initial
              display: inline-block
              left: 50%
              transform: translateX(-50%)
              margin-bottom: 20px

              &:after
                top: -20px
                left: -20px

              img
                min-width: initial
                display: block
                margin: 0 auto

            figcaption
              width: 100%
              padding: 0
              text-align: left
</style>
